import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, combineLatest as observableCombineLatest } from "rxjs";
import { distinctUntilChanged, first, map } from "rxjs/operators";

import { BaseListingPageComponent } from "../base-listing-page";

/**
 * This provides an out-of-the-box listing page with pagination and a query (text search)
 * Use the page$ observable to show pagination status
 * Use query$ to update the query$ and display it in a search bar.
 *
 * After extending this component, you still need to define:
 * - loadEntities method
 * - pageRoute property
 * Everything else from the BaseListingPageComponent is ready to go.
 *
 * If you want additional filters beyond pagination and a text query, you can use this
 * file as an example of how to implement them, *BUT* it's probably easier to extend
 * BaseListingPageComponent directly.
 */
export abstract class BaseListingPageWithQuery extends BaseListingPageComponent {
  query$ = new BehaviorSubject<string>("");

  constructor(router: Router, route: ActivatedRoute) {
    super(router, route);
  }

  protected initComponentQueryParameters$(): void {
    this.componentQueryParameters$ = observableCombineLatest([
      this.query$.pipe(
        distinctUntilChanged(),
        map((query) => ({ filter: query }))
      )
    ]);
  }

  protected setComponentQueryParamsFromRouteParams$(): void {
    const {
      queryParams: { filter }
    } = this.route.snapshot;

    this.query$.pipe(first()).subscribe((currentFilter) => {
      if (filter !== currentFilter) {
        this.query$.next(filter);
      }
    });
  }
}
